import { Button } from '@wordpress/components'
import { useDispatch, useSelect } from '@wordpress/data'
import { MediaUpload } from '@wordpress/block-editor'

const MetaPhoto = ({ fieldName, label }) => {
  const metaFieldValue = useSelect(
    select => select('core/editor').getEditedPostAttribute('meta')[fieldName],
    []
  )

  const setMetaFieldValue = useDispatch('core/editor').editPost

  return (
    <div className='image-upload'>
      {(() => {
        if (metaFieldValue) {
          return <img className='image-upload-item' alt={label} src={metaFieldValue} />
        } else {
          return <span>{label}</span>
        }
      })()}
      <MediaUpload
        value={metaFieldValue}
        onSelect={media => setMetaFieldValue({ meta: { [fieldName]: media.url } })}
        render={handleClick => (
          <Button className='button button-large image-upload-button' onClick={handleClick.open}>
            {!metaFieldValue ? 'Upload/Select Photo' : 'Change Photo'}
          </Button>
        )}
      />
    </div>
  )
}

export default MetaPhoto
